import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import TestimFamily from '../../images/testimfamily.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const dotsSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    focusOnSelect: true,
};
class WhatParentsSay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {
        return (
            <section className="page-section bg-secondary text-white testimsec">
                <h2 className="yellowtxt">What Parents Say</h2>
                <div
                    id="myCarousel"
                    className="carousel slide"
                    data-ride="carousel"
                >
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...dotsSettings}
                        className="carousel-indicators"
                    >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        
                    </Slider>
                    <Slider
                        {...settings}
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        className="carousel-inner"
                    >
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “This gym is what has been missing in the Shorewood area. My son is 5 years old and on the spectrum. This is his new happy place! It is an amazing feeling to go somewhere where he can just be himself without judgement. Amy, her husband, and Payton truly care about the gym and the parents and kiddos that walk through that door. Thank you for creating such a welcoming environment!”                            </p>
                            <p className="overview">Heather O.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “We love this place, we just did my daughter’s party and we couldn’t be happier with the service and kindness. Everyone had a great time, even the adults. Super stress free. The party room was the perfect size as well.”                            </p>
                            <p className="overview">Judith S. </p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “We had such a great time here! My two boys are huge sensory seekers and this is the perfect place for them to have a blast without the worry of them injuring themselves. So much equipment, extremely clean, the owner is so friendly and love that she was so open to suggestions about things to improve on. We will be back again and again!"                            </p>
                            <p className="overview">
                            Brittany V. </p>
                        </div>

                         <div className="item carousel-item">
                            <p className="testimonial">
                            “I recently brought my almost 2 year old and it blew our expectations out of the water. Even tho it’s a kids play area it is so calm and organized. We stayed for a little over an hour and he was so devastated to leave. We will definitely be returning."                            </p>
                            <p className="overview">
                            Nickii M.</p>
                        </div> 
                         <div className="item carousel-item">
                            <p className="testimonial">
                            “By far the best place to take your kids to just be kids! Highly recommend."                            </p>
                            <p className="overview">
                            Caleigh B.</p>
                        </div> 
                         <div className="item carousel-item">
                            <p className="testimonial">
                            “Our kids had an absolute blast there! A ton of different things for kids of all ages to do. It was very clean too! We'll definitely be looking into a membership here and plan to be frequent visitors."                            </p>
                            <p className="overview">
                            Elizabeth S.</p>
                        </div> 
                         <div className="item carousel-item">
                            <p className="testimonial">
                            “Such a great place! We were here for a field trip with my son and his class and it was an all around great experience! Staff was kind and personable and there were so many fun things for the kids to play with and on!"                            </p>
                            <p className="overview">
                            Caitlin C.</p>
                        </div> 
                       
                    </Slider>
                    <img
                        className="quoteimg"
                        src={TestimFamily}
                        alt="Testimonials family"
                    />
                </div>
            </section>
        );
    }
}

export default WhatParentsSay;
